/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  GET_FAQ_REQUEST,
  GET_FAQ_SUCCESS,
  GET_FAQ_FAILURE,
  GET_FAQ_DETAILS_REQUEST,
  GET_FAQ_DETAILS_SUCCESS,
  GET_FAQ_DETAILS_FAILURE,
} from "./faqTypes";

const initialState = {
  loading: false,
  faq: {},
  error: "",
};

const getFaqReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAQ_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FAQ_SUCCESS:
      return {
        loading: false,
        faq: action.payload,
        error: "",
      };
    case GET_FAQ_FAILURE:
      return {
        loading: false,
        faq: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForFaqDetails = {
  loading: false,
  faq: {},
  error: "",
};

const getFaqDetailsReducer = (state = initialStateForFaqDetails, action) => {
  switch (action.type) {
    case GET_FAQ_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FAQ_DETAILS_SUCCESS:
      return {
        loading: false,
        faq: action.payload,
        error: "",
      };
    case GET_FAQ_DETAILS_FAILURE:
      return {
        loading: false,
        faq: {},
        error: action.payload,
      };
    default:
      return state;
  }
};

export { getFaqReducer, getFaqDetailsReducer };
